const config = {
  LoginMensaje: process.env.REACT_APP_LoginMensaje,
  LoginLogoTamanio: process.env.REACT_APP_LoginLogoTamanio,
  ApiKey: process.env.REACT_APP_ApiKey,
  GoogleKey: process.env.REACT_APP_GoogleKey,
  MsSsoClientId: process.env.REACT_APP_MsSsoClientId,
  MsTenantId: process.env.REACT_APP_MsTenantId,
  SiriusSSOTokenKey: process.env.REACT_APP_SiriusSSOTokenKey,
  UrlLoginServer: process.env.REACT_APP_UrlLoginServer,
  UrlApiProject: process.env.REACT_APP_UrlApiProject,
  UrlProject: process.env.REACT_APP_UrlProject,
  HereKey: process.env.REACT_APP_HereKey,
  KrakenService: process.env.REACT_APP_KrakenService,
  DebuggingMode: process.env.REACT_APP_DebuggingMode,
};

function GetToken() {
  return sessionStorage.getItem('Token');
}

export { config, GetToken };
